import React, { useEffect, useMemo, useState } from 'react';
import { Formik } from 'formik';
import { CSSTransition } from 'react-transition-group';
import './styles.css';
import BasicButton from '../../../../components/BasicButton';
import BasicButtonGroup from '../../../../components/BasicButtonGroup';
import BasicCheckbox from '../../../../components/BasicCheckbox';
import BasicSubmitButton from '../../../../components/BasicSubmitButton';
import HorizontalLoader from '../../../../components/HorizontalLoader';
import LoadMask from '../../../../components/LoadMask';
import {ANIMATION_TIMEOUT_APPEAR} from '../../../../constants/animation';
import ENDPOINT from '../../../../constants/endpoints';
import {get, post} from '../../../../services/api';

const TeamSetAccessLimitsForm = props => {
  const {
    actions: { proceed, dismiss, cancel },
    params: { id },
  } = props;
  const [formState, setFormState] = useState({ init: false });

  useEffect(() => {
    let isMounted = true;
    get(
      ENDPOINT.FORM.GET.TEAM,
      { id },
      {
        handleError: response => cancel(response),
        handleSuccess: formData => {
          if (isMounted) {
            setFormState({ init: true, ...formData });
          }
        },
      }
    );

    return () => {
      isMounted = false;
    };
  }, []);

  const handleSubmit = (values, { setSubmitting }) => {
    const checked = Object.keys(values)
      .filter(field => values[field])
      .map(val => val.replace(/^al/, ''));

    post(
      ENDPOINT.FORM.SAVE.TEAM,
      { id, permissions: checked },
      {
        handleError: response => cancel(response),
        handleSuccess: () => {
          setSubmitting(false);
        },
      }
    ).then(proceed);
  };

  const initialValues = useMemo(
    () =>
      formState.init
        ? Object.keys(formState.fields).reduce((values, field) => {
            values[field] = formState.fields[field].checked;
            return values;
          }, {})
        : null,
    [formState]
  );

  return formState.init ? (
    <CSSTransition
      in={true}
      appear={true}
      timeout={ANIMATION_TIMEOUT_APPEAR}
      classNames="fade"
    >
      <div className="form__inner candidate-status-form">
        <Formik initialValues={initialValues} onSubmit={handleSubmit}>
          {({
            values,
            handleChange,
            handleSubmit,
            isSubmitting,
          }) => (
            <form onSubmit={handleSubmit} className="form__content">
              {isSubmitting && <LoadMask />}

              <div
                className="form__group form__group--compact"
                style={{ marginBottom: '0' }}
              >
                {Object.keys(initialValues)
                  .filter(
                    f =>
                      Number(formState.fields[f].value) <= 8 ||
                      Number(formState.fields[f].value) === 12
                  )
                  .map((field, index) => (
                    <div className="form__row" key={index}>
                      <BasicCheckbox
                        value={values[field]}
                        singleRow
                        checked={values[field]}
                        title={formState.fields[field].label}
                        name={field}
                        controlFunc={handleChange}
                        labelStyles={{
                          fontFamily: 'Noto Sans, sans-serif',
                        }}
                      />
                    </div>
                  ))}

                {Object.keys(initialValues)
                  .filter(
                    f =>
                      Number(formState.fields[f].value) > 8 &&
                      Number(formState.fields[f].value) !== 12
                  )
                  .map((field, index) => (
                    <div className="form__row" key={index}>
                      <BasicCheckbox
                        value={values[field]}
                        singleRow
                        checked={values[field]}
                        title={formState.fields[field].label}
                        name={field}
                        controlFunc={handleChange}
                        labelStyles={{
                          fontFamily: 'Noto Sans, sans-serif',
                        }}
                      />
                    </div>
                  ))}
              </div>

              <div className="form__controls form__controls--compact">
                <BasicButtonGroup>
                  <BasicSubmitButton
                    controlFunc={handleSubmit}
                    btnWidth={200}
                    btnHeight={40}
                    btnFontWeight={500}
                    btnFontSize="0.8571rem"
                    btnArrow={true}
                    btnTextColor="#27282d"
                    btnText="Save"
                  />

                  <BasicButton
                    controlFunc={dismiss}
                    btnWidth={200}
                    btnHeight={40}
                    btnFontWeight={500}
                    btnFontSize="0.8571rem"
                    btnArrow={false}
                    btnTextColor="#27282d"
                    btnText="Cancel"
                  />
                </BasicButtonGroup>
              </div>
            </form>
          )}
        </Formik>
      </div>
    </CSSTransition>
  ) : (
    <div className="horizontal-loader__container">
      <HorizontalLoader />
    </div>
  );
};

export default TeamSetAccessLimitsForm;
